export const BRICO = 'brico'
export const PRAXIS = 'praxis'

export function getVdmPrefix(locale) {
  switch (locale) {
    case 'nl_BE':
      return '/nl/makers'
    case 'fr_BE':
      return '/fr/makers'
    default:
      return '/voordemakers'
  }
}

export function getLocale(format, language) {
  if (format === BRICO) {
    return language === 'nl' ? 'nl_BE' : 'fr_BE'
  }
  return 'nl_NL'
}

export function isPraxis(format) {
  return format === PRAXIS
}
